import React from "react";
import Nav from "@/components/Nav";
import { AUTH } from "@/constants/testIds";

export default function Login() {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-[color:var(--f2-bg)] min-h-screen text-white">
      <Nav />
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 grid-lines opacity-40 pointer-events-none" />
        <div className="max-w-[520px] mx-auto px-6 py-24 relative z-10">
          <div className="label-xs mb-4">§ Access</div>
          <h1 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl">
            Enter <span className="saffron">Forte² Space.</span>
          </h1>
          <p className="mt-4 text-[color:var(--f2-muted)]">
            Sign in with Google to take the Forte² Score and unlock your personalised space-economy report.
          </p>
          <div className="mt-10 hard-border bg-[color:var(--f2-surface)] p-8">
            <button
              data-testid={AUTH.googleButton}
              onClick={handleGoogle}
              className="btn-crisp btn-primary w-full justify-center"
            >
              Continue with Google →
            </button>
            <div className="mt-6 label-xs text-[color:var(--f2-muted)]">
              We use Emergent-managed Google Auth. No password required.
            </div>
          </div>
          <div className="mt-8 text-xs text-[color:var(--f2-muted)] leading-relaxed">
            By continuing you agree to processing under India's DPDP Act, 2023. You retain full rights to access,
            correct and erase your data.
          </div>
        </div>
      </div>
    </div>
  );
}
